import { split } from "lodash";
import Loading from "../../components/Loading";
import PageLayout from "../../layouts/PageLayout";
import QuotationAddPage from "../QuotationAdd";
import { useGetCustomerAttachmentQuery } from "../../utils/customerAttachment.utils";
import { useParams } from "react-router-dom";

export default function QuotationEditPage() {
  const { caid } = useParams();

  const id = caid ? split(caid) : "";

  const { loading, data } = useGetCustomerAttachmentQuery({
    query: `?caid=${caid}`,
    options: {
      enabled: !!caid
    },
    key: `QuotationEdit-${caid}`
  });

  const title = `${!!id ? "Edit" : "Add"} Quotation`;

  const breadCrumbs = [
    {
      name: "Quotation List",
      link: "/quotation-list"
    },
    {
      name: title
    }
  ];

  const formattedData = data;

  let editItem = formattedData;

  const isLoading = loading;

  return isLoading ? (
    <PageLayout title={title} breadCrumbs={breadCrumbs}>
      <Loading loading={isLoading} />
    </PageLayout>
  ) : (
    <QuotationAddPage editItem={editItem} />
  );
}
